import { PaletteMode, ThemeOptions } from "@mui/material";

declare module "@mui/material/styles" {
  interface PaletteOptions {
    dashboardTable?: {
      main: string;
      header: string;
    };
    table?: {
      secondary: {
        main: string;
      };
    };
    tableRow?: {
      dark: string;
    };
  }

  interface Palette {
    dashboardTable?: {
      main: string;
      header: string;
    };
    table?: {
      secondary: {
        main: string;
      };
    };
    tableRow?: {
      dark: string;
    };
  }
}

export const getThemeOptions = (mode: PaletteMode): ThemeOptions => ({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 2200,
    },
  },
  palette: {
    mode,
    primary: {
      main: mode === "light" ? "#A6631B" : "#E1B87F",
      light: "rgba(96, 80, 59, 1)",
    },
    secondary: {
      main: mode === "light" ? "#584292" : "#8D9AC7",
    },
    ...(mode === "dark" && {
      background: {
        paper: "#1E1E1E",
      },
    }),
    ...(mode === "dark" && {
      table: {
        secondary: {
          main: "#FFFFFF14",
        },
      },
      tableRow: {
        dark: "#1d1d1d",
      },
    }),
    ...(mode === "dark" && {
      dashboardTable: {
        main: "rgba(255, 255, 255, 0.07)!important",
        header: "rgba(255, 255, 255, 0.002)!important",
      },
    }),
    ...(mode === "light" && {
      background: {
        default: "#F5F5F5",
      },
    }),
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: "16px",
        },
        ...(mode === "light" && {
          elevation1: {
            boxShadow: "none",
          },
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          ...(mode === "dark" && {
            background: "#1E1E1E !important",
          }),
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: "16px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          "&:last-child": {
            paddingBottom: "16px",
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        action: {
          marginTop: "4px",
          paddingRight: "12px",
        },
      },
    },

    // MuiCssBaseline: {
    //   styleOverrides: {
    //     body: {
    //       scrollbarColor: mode === "light" ? "#DEE2E6 #F8F9FA" : "#6b6b6b #1E1E1E",
    //       "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    //         backgroundColor: mode === "light" ? "#F8F9FA" : "#1E1E1E0A",
    //       },
    //       "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    //         borderRadius: 8,
    //         backgroundColor: mode === "light" ? "#CED4DA" : "#6b6b6b",
    //         minHeight: 24,
    //         border: mode === "light" ? "2px solid #F8F9FA" : "2px solid #1E1E1E",
    //       },
    //       "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
    //         backgroundColor: "#959595",
    //       },
    //       "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
    //         backgroundColor: "#959595",
    //       },
    //       "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
    //         backgroundColor: "#959595",
    //       },
    //       "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
    //         backgroundColor: "#2b2b2b",
    //       },
    //     },
    //   },
    // },
  },
});
